// extracted by mini-css-extract-plugin
export var legendIndicator = "_bs-1";
export var legendRight = "_bs-0";